// Lib
import { FC } from "react";
import { Skeleton } from "antd";
// Types
import { OrderPaymentType } from "types/orders";
import { OrderDetailProps } from "./types";
// Theme
import { theme } from "theme";
// Icons
import { DiningIcon } from "icons";
// Helpers
import { fixedDigitsValue } from "helpers/dataHelpers";
// Components
import { Badge } from "components";
// Styled
import { ContentBox, FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";
import { MenuItem, Image, ImagePlaceholder } from "../styled";

export const OrderDetail: FC<OrderDetailProps> = ({
  isLoading,
  isScheduled,
  data,
  paymentType,
  loyaltyDiscountPercentage,
}) => {
  return (
    <ContentBox $column $gap={20}>
      <Typography.H2>Order detail</Typography.H2>

      {isLoading && <Skeleton active />}

      {!isLoading && (
        <FlexContainer $fullwidth $column $gap={12}>
          {data?.map(
            ({
              productId,
              productName,
              quantity,
              fmcCentsPrice,
              fiatCentsPrice,
              isSnoozed,
              subItems,
              imageURL,
              remark,
              tags,
            }) => {
              let price =
                paymentType === OrderPaymentType.FiatCents
                  ? fiatCentsPrice
                  : fmcCentsPrice;

              const priceTitle =
                paymentType === OrderPaymentType.FiatCents ? "KWD" : "FM coins";

              const nonLoyalty = !!tags?.find(tag => tag === "non-loyalty");

              if (loyaltyDiscountPercentage && !nonLoyalty) {
                price *= (100 - loyaltyDiscountPercentage) / 100;
              }

              return (
                <MenuItem key={productId} $fullwidth $padding="8px" $gap={8}>
                  <div>
                    {imageURL ? (
                      <Image src={imageURL} />
                    ) : (
                      <ImagePlaceholder>
                        <DiningIcon height={"64px"} width={"64px"} />
                      </ImagePlaceholder>
                    )}
                  </div>

                  <FlexContainer
                    $fullwidth
                    $column
                    $gap={8}
                    $padding="4px 0 0 0"
                  >
                    <FlexContainer $gap={8} $wrap>
                      <Typography.Title>{productName}</Typography.Title>
                      {isScheduled && isSnoozed && (
                        <Badge
                          title="Out of stock"
                          textColor={theme.color.white}
                          bgColor="rgba(250, 80, 69, 1)"
                        />
                      )}
                    </FlexContainer>

                    <Typography.DescriptionThin>
                      {priceTitle}: {fixedDigitsValue(price, 3)} · Quantity:{" "}
                      {quantity} items
                    </Typography.DescriptionThin>

                    {remark && (
                      <Typography.DescriptionThin>
                        Note: {remark}
                      </Typography.DescriptionThin>
                    )}

                    {!!subItems?.length && (
                      <FlexContainer $fullwidth $column $padding="5px 0 0 0 ">
                        {subItems.map((item, i) => (
                          <Typography.DescriptionThin key={item.productId + i}>
                            {item?.quantity || 1} x {item?.productName}
                          </Typography.DescriptionThin>
                        ))}
                      </FlexContainer>
                    )}
                  </FlexContainer>
                </MenuItem>
              );
            },
          )}
        </FlexContainer>
      )}
    </ContentBox>
  );
};
